import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';

const ActionTypes = AdminConstants.ActionTypes;

export default {
  upsertACIZonesSuccess() {
    AdminAppDispatcher.handleServerAction({
      type: ActionTypes.UPSERT_ACI_ZONES_SUCCESS,
    });
  },
  upsertACIZonesFail(error) {
    AdminAppDispatcher.handleServerAction({
      type: ActionTypes.UPSERT_ACI_ZONES_FAIL,
      error,
    });
  },
};
